import { useEffect } from "react";
import { useLanguage } from "@/context/LanguageContext";

function setMeta(attr, key, value) {
  const el = document.querySelector(`meta[${attr}="${key}"]`);
  if (el) el.setAttribute("content", value);
}

export default function Seo({ page }) {
  const { lang, t } = useLanguage();

  useEffect(() => {
    const s = t.seo?.[page];
    if (!s) return;
    document.title = s.title;
    document.documentElement.lang = lang;
    setMeta("name", "description", s.desc);
    setMeta("property", "og:title", s.title);
    setMeta("property", "og:description", s.desc);
    setMeta("property", "og:locale", lang === "de" ? "de_DE" : "en_US");
    setMeta("name", "twitter:title", s.title);
    setMeta("name", "twitter:description", s.desc);
  }, [page, lang, t]);

  return null;
}
